import TableHeading from './TableHeading';

export default TableHeading;
